/* eslint-disable no-useless-escape */
import { getGS } from '@kk-activity-factory/utils';
import globalData from '@kk-activity-factory/global-data';

const innerPreview = globalData.innerPreview;
const prewViewId = globalData.prewViewId;

export async function gsInterceptor(opt) {
    /**
     * 正则校验 list
     */
    const needGsAPIRegList = [
        /gamecard\/v2\/multi_position_lottery\/create_order$/,
        /gamecard\/v2\/multi_position_lottery\/do_lottery$/,
        /gamecard\/v2\/richman\/playGame$/,
        /gamecard\/v2\/activity\/puzzle\/convert$/,
        /gamecard\/v2\/activity\/puzzle\/reward$/,
        /gamecard\/v2\/realtime\/reward\/obtainReward$/,
        /gamecard\/v2\/redEnvelopeRain\/collect$/,
        /gamecard\/v2\/collect_card\/card\/draw$/,
        /gamecard\/v2\/activityModule\/answer$/,
        /gamecard\/v2\/activityModule\/obtainReadingVoucher$/,
        /gamecard\/v2\/activityModule\/signIn$/,
        /gamecard\/v2\/leftRightShow\/addHistory$/,
        /gamecard\/v2\/activityModule\/allFav$/,
        /gamecard\/v2\/develop\/play$/,
        /gamecard\/v2\/notification\/subscribe$/,
        /gamecard\/v2\/vote\/ballot$/,
        /gamecard\/activity\/lottery$/,
        /gamecard\/v2\/activity\/lottery$/,
        /gamecard\/v2\/questcontainer\/info$/,
        /gamecard\/v2\/questcontainer\/obtain\/reward_batch$/,
        /gamecard\/v2\/questcontainer\/obtain\/reward$/,
        /gamecard\/v2\/questcontainer\/quest\/update\/progress$/,
        /gamecard\/v2\/exchange\/prize\/obtain$/,
        /v1\/danmu\/video\/send$/,
        /gamecard\/v2\/stagedCharge\/singleCharge$/,
        /gamecard\/v2\/stagedCharge\/obtainStagePrize$/,
        /v1\/graph\/h5\/comments\/([^\/]*)\/favbury\/v2/,
        /v1\/graph\/posts\/h5\/([^\/]*)\/comments$/,
        /v1\/graph\/posts\/h5\/([^\/]*)\/fav/,
        /v1\/graph\/users\/h5\/([^\/]*)\/follow$/,
        /gamecard\/v2\/activityModule\/visit\/obtainPrize$/,
        /gamecard\/v2\/stratificationStagePrize\/info$/,
        /gamecard\/v2\/stratificationStagePrize\/obtainPrize$/,
        /gamecard\/v2\/activity\/prizeShow\/obtainPrize$/,
        /gamecard\/v2\/topicRank\/peltCoin$/,
    ];
    const url = opt.url;
    for (let i = 0; i < needGsAPIRegList.length; i++) {
        if (needGsAPIRegList[i].test(url)) {
            const sign = await getGS(new Date().getTime());
            opt.url = /\?/.test(url) ? `${url}&answer=${sign}` : `${url}?answer=${sign}`;
            if (innerPreview) {
                opt.url = `${opt.url}&previewId=${prewViewId}`;
            }
        }
    }
    return Promise.resolve(opt);
}
